/* eslint-disable @typescript-eslint/naming-convention */

// 💀⚡💀 DO NOT EDIT THIS FILE 💀⚡💀 DO NOT EDIT THIS FILE 💀⚡💀 DO NOT EDIT THIS FILE 💀⚡💀

/*////////////////////////////////////////////////////////////////////////////////////////////////

  ##### ##### ##### ##### |   This file is autogenerated using an Nx workspace schematic.
  #       #   #   # #   # |   Manual changes should not be needed. After adding your feature 
  #####   #   #   # ##### |   to software security, simply regenerate this file by running
      #   #   #   # #     |   `nx g security-constants`. If there is an issue
  #####   #   ##### #     |   with the generated file, check tools/generators/security-constants

////////////////////////////////////////////////////////////////////////////////////////////////*/

export const SecurityConstants = {
  account_page: '6fda5d89-eb76-4f17-b927-24004a1613f2',
  add_new_material: 'd4759063-595b-4efc-b094-0a0313bccaae',
  bd_opportunity_totals: 'bd40d61f-3ef3-4755-8042-8ae269a11a17',
  bd_opportunity_values: 'e1c91199-8fd6-4cb6-b8f7-01d7a2dfef06',
  contact_page: 'dd666118-f492-4972-8563-50ba0965c084',
  data_reconciliation_admin: 'd8ba05cf-1d1e-4684-b218-d59d06633ce6',
  employee_portal_equipment_equipmentdispatchcustomview:
    '94e2b367-1a5e-4d83-9b8b-dfd6038bb571',
  employee_portal_equipment_equipmentdispatchgrid:
    '806b79a4-5b71-4784-a9e9-8aad0e209c42',
  employee_portal_app_switcher_viewappswitcher:
    'f29dd3c3-700b-4968-9958-7b4434ba2113',
  employee_portal_custom_export_customexportpage:
    '393dc619-4444-4e48-bde9-02eaac5c63b6',
  employee_portal_dispatch_dashboard_allowdispatchof2monthormoreofinactivity:
    'b315f122-a44e-43f6-a500-5e6329a0aa2a',
  employee_portal_dispatch_dashboard_allowdispatchof6monthormoreofinactivity:
    'b943412d-3ecc-47cd-8759-46cdcf06f22d',
  employee_portal_dispatch_dashboard_allowdispatchofinactiveemployees:
    '9f84a0aa-01d6-4928-b64d-d7311338ceb8',
  employee_portal_dispatch_dashboard_allowdispatchofinactiveemployees0_6months:
    '4e19d31d-7144-4adc-bc10-347d9da7df7b',
  employee_portal_dispatch_dashboard_allowdispatchofinactiveemployeeswithcautionstatus:
    'ed6a80e5-cdd0-4dc7-9593-17bcfd2fc8f5',
  employee_portal_dispatch_dashboard_allowperdiemabove500:
    'af2014dd-74d0-457d-afb5-cabd09482669',
  employee_portal_dispatch_dashboard_copyjobcrew:
    '0cedbffa-742b-4ffc-89be-74fa7d037098',
  employee_portal_dispatch_dashboard_dispatchhistory:
    'f5506b34-9e73-4188-853c-c79dd618905c',
  employee_portal_dispatch_dashboard_transferemployeecompany:
    'f34fd454-ced9-4f31-b343-50a145df71dc',
  employee_portal_dispatch_rates__autopopulatewage:
    '1b1d5ef6-45b8-468f-a943-419b2cbc3cdd',
  employee_portal_dispatch_rates__contactperdiem:
    'b9a3cffa-b739-4f95-9dde-1b6c52e3bb02',
  employee_portal_dispatch_rates__contractptfactor:
    '2694c08e-535a-4fcc-ba6a-10abdb9c2577',
  employee_portal_dispatch_rates__dispatchcontractrate:
    '0340e3b0-24da-42e8-8388-6d050fd15629',
  employee_portal_dispatch_rates__fieldpayrate:
    '878173bc-24a4-41c5-8eff-bf3470162583',
  employee_portal_dispatch_rates__filepayrate:
    '399a8a51-39c9-4d99-893a-73cf85938e83',
  employee_portal_dispatch_rates__nonbillablepayrate:
    '76d59e9e-1aeb-43ce-be11-2cce0699a850',
  employee_portal_dispatch_rates__shoppayrate:
    'a9f8bff2-12e7-4c62-82fc-958a343faa43',
  employee_portal_dispatch_rates__wageover99:
    'e29b9f6b-3b28-4950-b00d-6b5ac0a0cc10',
  employee_portal_dispatch_status_adminpage:
    'fc54bfd4-1432-4f5b-83b0-9455d5818cb6',
  employee_portal_dispatch_status_adminpagecustomview:
    '89986eee-72b0-426e-aec5-a36a9d9a7ad3',
  Employee_Portal_Dispatch_Status_changecomplianceholdstatus:
    'c4abb77b-a16f-4a4f-802b-8b485698f4da',
  employee_portal_dispatch_status_savedeclinedfromcaution_notrehirable_medicalreleaserequired:
    '17e3b55f-5194-4e30-ad60-008458263790',
  employee_portal_dispatch_status_savedeclinedfromdispatched:
    '4d5f39a5-e2d9-4ae5-8899-d4fa62118823',
  employee_portal_dispatch_status_temp: 'f1987f1f-84e4-4286-a9ca-6259011c407d',
  employee_portal_employee_jobs_list_customview:
    '5be435c6-69d3-413a-95d5-690effd0c3c6',
  employee_portal_employee_profile_backgroundtabmvr:
    'b3211494-0541-457b-b650-e9ff65a8cc61',
  employee_portal_employee_profile_fullssn:
    'f6da7846-ed19-4f85-9890-caccd89e9da3',
  employee_portal_employee_profile_jobhistorypayrate:
    '89a01c1f-2719-41be-b1cb-5f3e4cd2a1fb',
  Employee_Portal_Employee_Profile_rehirestatus_caution:
    'e24cc6d6-2dba-44a7-a99e-a47f9f3c7989',
  Employee_Portal_Employee_Profile_rehirestatus_notrehirable:
    '71c9b663-79e6-4aa5-9e67-f8238124bad9',
  employee_portal_equipment_administration_equipmentadministrationdashboard:
    '5f9d0a96-fb3d-4010-990a-4640f6aa2a0d',
  employee_portal_equipment_correctionsauditcustomview:
    '5bb29077-c256-4d25-84e5-5b32d9026e02',
  employee_portal_equipment_correctionsauditpage:
    '8b09e20c-f33b-4b2e-8bda-cec3df4e8217',
  employee_portal_equipment_equipmentdashboard:
    'b6c10796-3ccd-43e7-b98d-f900871fefb0',
  employee_portal_equipment_equipmentdashboardbulkedit:
    '21596cce-e7d3-4f85-8620-eb92fd6fa0b6',
  employee_portal_equipment_equipmentdashboardcustomview:
    '28714d10-3583-4d7c-9a1a-643e6db030dd',
  employee_portal_equipment_equipmentdashboardscorecardtab:
    '9f9ce6c9-8930-4332-b537-dd290ec8abd4',
  employee_portal_equipment_equipmentreallocation:
    '1e867bda-a9fa-4bd1-87bf-b8b1b6b1aea0',
  employee_portal_equipment_equipmentresourcehyperlink:
    '1b28aa6e-b161-4141-8f44-cb39b0f82197',
  employee_portal_equipment_equipmentsearch:
    'f64cce1f-da87-4e8a-8309-5decb2728081',
  employee_portal_equipment_equipmentsearchcustomview:
    'eb53e617-3599-486b-9531-cf979c12e4dd',
  employee_portal_equipment_equipmentusage:
    'e949dc36-d5c4-4403-b673-b305b4c575d3',
  employee_portal_equipment_equipmentusagecustomview:
    'a9b45b69-7dbb-4c9d-8a7b-fcfb91f28564',
  employee_portal_equipment_resources_bulkedit:
    '2292ee39-4a43-45b4-8621-dca516d502a7',
  employee_portal_equipment_resources_calibrationstab:
    '5544b91b-72aa-43af-aa1c-2005b752680b',
  employee_portal_equipment_resources_equipmentlocationhistorytab:
    '3c44e3ed-6828-4c30-8a4a-e749c5303bae',
  employee_portal_equipment_resources_equipmentnotestab:
    'ca683804-eb0b-4731-9b82-c9f190e7f299',
  employee_portal_equipment_resources_equipmentrequesthistorytab:
    '30da4fb4-0ab5-4e8d-beb0-2242ce7ebcd3',
  employee_portal_equipment_resources_equipmentresourcescustomview:
    'a00b523d-1adc-4316-a031-2b15c146ac44',
  employee_portal_equipment_resources_fixedassethistorytab:
    'dff7a955-7b85-4a9b-aa41-8f69069c1aeb',
  employee_portal_equipment_resources_infotab:
    '50b3e17a-9218-444d-8db3-3091793bf004',
  employee_portal_equipment_resources_inspectiontab:
    'a8a649c2-e07d-4196-8ea0-d21c74663027',
  employee_portal_equipment_resources_jobhistorytab:
    'b1286b03-138d-4e09-a866-a37cc1615998',
  employee_portal_equipment_resources_mechanicnotestab:
    'edff4f4d-5535-4140-bb59-1b63d9340b7e',
  employee_portal_equipment_resources_meterstab:
    'c0013e04-5e46-4e2d-ac41-fbe472d1c900',
  employee_portal_equipment_resources_ownershipinfotab:
    'b5f59e15-b7dc-4918-8626-5ddcc1f48935',
  employee_portal_equipment_resources_rentalreleaseinfotab:
    '42c7fa02-772a-450a-bfd0-4311ab99e817',
  employee_portal_equipment_resources_scheduletab:
    '75e0ae00-b232-49ea-8cda-0ae64e3df7c8',
  Employee_Portal_Foreman_Allocation_foreman_allocation_sheet:
    'b1a11ed7-2e96-4909-a195-5a3810c3d1dc',
  employee_portal_foreman_crews_canmovetoonsite:
    '5690c19e-3305-4982-bc2c-22e98a5bfea1',
  employee_portal_foreman_crews_canoverridelabortype:
    '19827c02-a033-4bd0-97e2-66f7da0b8351',
  employee_portal_foreman_crews_foremancrewscustomview:
    '49bd7f11-9d95-4c28-b912-4c620bdb796f',
  employee_portal_foreman_crews_foremancrewspage:
    '03d24ea5-da82-4ab6-b9db-24842baf4ddd',
  employee_portal_foreman_crews_foremanmassrelease:
    '5ddcf063-f447-40c3-9ea7-3f753e54b50d',
  Employee_Portal_Foreman_Crews_labortypebulkedit:
    '9ee3f664-850c-4271-80ae-bc6604fef76b',
  employee_portal_foreman_crews_labortypesetup:
    'a08100dc-cb89-42e3-acd8-e391ae27408a',
  employee_portal_foreman_crews_labortypesetupcustomview:
    'aacaa3e4-215d-4f70-9c9c-55a80ad8e01a',
  Employee_Portal_Foreman_Crews_labortypesetuphistory:
    '5c3b9a83-69d3-47e5-a499-a9e347fcc8d8',
  employee_portal_frameworkfeatures_helpdocuments:
    '18981789-9d10-4b02-92e3-4b2bffbbca92',
  employee_portal_frameworkfeatures_tooltips:
    'b62974b9-2108-4b89-8b38-b9e0128f6c9d',
  employee_portal_frameworkfeatures_walkthroughs:
    'bea227a0-a7bb-4474-b60d-20a8bdfd9bc0',
  employee_portal_interestsubmittedtab_assigntootherjobs:
    'f499dcfb-577b-4f41-b4bd-89101a80f570',
  employee_portal_job_requirements_caneditoverflow:
    'e3524248-0c57-4a76-8a90-45f8524ff43e',
  employee_portal_job_requirements_trainingsubtasksgroups:
    'f8f2b13c-dfb5-499d-b83c-b485888bb965',
  employee_portal_manpower_pop_up_ocrtrainings:
    '8b25b944-18fa-4b46-89d7-62f818054f3b',
  Employee_Portal_Manpower_Pop_Up_safetytime:
    'f3cbd1a4-f4e2-4cd3-bb84-3f3d47b105bb',
  employee_portal_manpower_pop_up_trainingexpirations:
    'b09abd77-68af-4c0c-9771-016e83f62553',
  employee_portal_mileage_rates_mileageratescustomview:
    '3ec8cae6-b4b4-48a8-a6b2-cd65ff018257',
  employee_portal_mileage_rates_mileageratesdashboard:
    '763819c3-36bb-44d6-9fb0-7b5c05e0d011',
  Employee_Portal_My_UPS_myteam: 'd09b89ee-28e1-4201-b174-7c640a42e998',
  employee_portal_navigation_canseeadminexpertiseareas:
    '4ea405e7-6d30-4d21-af18-030a662cec3b',
  employee_portal_navigation_canseeadminplants:
    '2b827952-b67c-4f89-997f-1a7a4bd39610',
  employee_portal_navigation_canseeadminprospectivejobs:
    '32d5e933-6255-42e5-8208-d130bee5cee2',
  employee_portal_navigation_canseeemployeesaroundplant:
    '043a189b-623b-4208-995b-46850c937ef0',
  employee_portal_navigation_canseeequipmentdashboard:
    '93e8f547-bad0-48e5-96d4-f4ef7ae8db5a',
  employee_portal_navigation_canseeequipmentresources:
    '988957dc-87d4-4620-b441-586630e95a10',
  employee_portal_navigation_canseeforemancrews:
    'aac24c73-ba34-42f4-b880-4a74a8fbad45',
  employee_portal_navigation_canseereports:
    '00aceadf-e05b-4efa-b79e-f10c4a47b093',
  employee_portal_navigation_canseesyncpage:
    '958e410f-4e8c-4a5e-ab95-03063fdb0fa4',
  employee_portal_parent_customers_parentcustomerscustomview:
    'e3ce1dfa-52a6-407e-b9fd-f350ff3a69cb',
  employee_portal_pay_sequence_rules_paysequencerulescustomview:
    'a000e0b7-b7b6-4ffe-80e4-666a4fdf5266',
  employee_portal_pay_sequence_rules_paysequencerulesdashboard:
    '482d0f5b-d0fd-4368-9098-7b406211ee54',
  employee_portal_pay_sequences_paysequencescustomview:
    'e506272f-7388-47d3-b45d-01d28b7c6f54',
  employee_portal_pay_sequences_paysequencesdashboard:
    '6bdad9fd-3081-444a-aa70-61d8cddcafff',
  employee_portal_reports_reportcategoriesassignment:
    '18d0b730-5a85-44b1-919a-2122186b3dac',
  employee_portal_reports_reportcategoriescontrol:
    '08c3545e-ca1d-4933-8a2b-3016f37fc9e5',
  employee_portal_reports_reportscustomview:
    '4c1cd485-e7c4-415d-aa55-9d14d5c0ad40',
  employee_portal_reports_reportspage: '8d7381d1-b847-410b-b2e0-e2d6218d4df1',
  employee_portal_reports_reportspartarolesassignment:
    'e23b59fa-6685-439a-9180-995a9c5c8bf1',
  employee_portal_reports_reportsync: '02b9cf66-0179-4d62-a660-5590114dda6d',
  Employee_Portal_Security_Power_Bi_securityroles:
    '0f56421f-f3ff-4bac-b178-b3b68d18e239',
  Employee_Portal_Sparta_Navigation_cost_detail:
    '4dc2abd1-5857-43b8-97f5-725f9a852134',
  employee_portal_sparta_navigation_customexport:
    '857ef57a-8d72-4916-9d57-93b099c5fbe1',
  employee_portal_sparta_navigation_dispatchstatuses:
    '8609e631-e61c-400b-ae62-faf03da79ebb',
  employee_portal_sparta_navigation_employeedispatch:
    '8198303d-ad0a-42ca-9619-6aa63c8f53f6',
  employee_portal_sparta_navigation_equipmentdispatch:
    '1984c542-e1eb-4dde-af2d-454f85e7215a',
  employee_portal_sparta_navigation_equipmentsearch:
    '1026b11c-d973-4bb6-bdcd-cac1b747e60b',
  employee_portal_sparta_navigation_equipmentusage:
    '68ee32b8-56eb-4caf-b8ad-2a7975ef2488',
  employee_portal_sparta_navigation_exports:
    '7c72d395-7c15-4fc0-aaff-910e0c405ce2',
  employee_portal_sparta_navigation_foremancrews:
    '2016b5f9-3cac-40f7-bcba-e798f243599d',
  employee_portal_sparta_navigation_jobrequirements:
    'afab2877-85f6-40cb-b2eb-514507b900de',
  employee_portal_sparta_navigation_labortypesetup:
    '81c64e9f-88e4-45f5-85a1-1cfbfccba54c',
  employee_portal_sparta_navigation_mileagerates:
    '903206f4-188b-414f-a907-96b19b951a67',
  employee_portal_sparta_navigation_parentcustomer:
    'fa502b3b-bcf9-499d-b15d-ad74bcaf1f7b',
  employee_portal_sparta_navigation_parentfacility:
    '088e05ed-4a96-4a05-adfc-f50442f6237f',
  employee_portal_sparta_navigation_paysequences:
    'c368bc5b-2599-47c5-bd83-40ee0ba9914a',
  employee_portal_sparta_navigation_plants:
    '96b2ebdc-2239-4d7a-8118-c52faffac407',
  employee_portal_sparta_navigation_reports:
    '391a1fbd-233d-4704-b316-82bda764ead6',
  employee_portal_sparta_navigation_sync:
    'aac74d15-2900-41ac-8a33-ec7474976f89',
  employee_portal_sparta_navigation_timein_timeout:
    'a24efa72-252a-4164-bc5f-03de27f64b47',
  employee_portal_sparta_navigation_timekeeping:
    '9d135474-fc73-4741-8f3d-db0fc707c530',
  employee_portal_sparta_navigation_timekeepingchecklist:
    '9ddcddf2-d84b-4691-8d62-9c3c0c81bfa9',
  employee_portal_sparta_navigation_timekeepingsearch:
    '9ce2c871-45c5-4145-8828-6e87b62ae3f3',
  employee_portal_sparta_navigation_timesheet:
    'fab0a72a-63b1-49bb-88b2-4db299e19d39',
  employee_portal_sparta_navigation_workorders:
    '214ab865-e685-4265-8a04-cd9131946653',
  employee_portal_sparta_navigation_equipmentcorrectionsaudit:
    '0b64de56-39cc-4b43-bfbf-fbd1ee918a9a',
  Employee_Portal_SPARTA_Navigation_foremanequipmentimport:
    '8b00ae31-4188-424d-9cf4-29b88f087b3b',
  Employee_Portal_SPARTA_Navigation_foremantimeimport:
    '9aa08850-dc62-4ccf-99a0-475416d8978e',
  Employee_Portal_SPARTA_Navigation_foremantimemanager:
    'd032dc05-a9de-4494-b94e-a29636d7788d',
  employee_portal_sparta_navigation_timekeepingcorrectionsaudit:
    '9e4380ed-ded1-4dac-a564-70d6836c8073',
  employee_portal_supers_publishtableviews:
    'c6b81557-7e1a-43ed-9b3f-0bafae8ae793',
  employee_portal_supers_savedefaulttableviews:
    '5c7d1b81-7204-4342-89af-dbae3b658609',
  employee_portal_supers_setdispatchstatus:
    'c35f48e9-b6be-4b28-a071-9f0509af92f9',
  employee_portal_sync_syncspartapage: '642ee98f-83dc-49a5-9e4b-7059bdb33bdf',
  employee_portal_timekeeping_14dayextendedun_rof:
    '93de1df3-3993-4413-b1bd-ba38ef4e2985',
  employee_portal_timekeeping_badge_scan:
    'a5f3f69c-92eb-4d3b-a44a-99d8dbf7abcd',
  Employee_Portal_Timekeeping_canapplystepup:
    'e627a60e-fcb2-4a3a-a255-ebc0ebef4957',
  employee_portal_timekeeping_canmovetoonsite:
    'ba2a8c92-afd2-4acf-9f36-3cf60d851b15',
  employee_portal_timekeeping_canrof: 'cc7e0097-da85-4a4f-9984-ab4fb80c053d',
  employee_portal_timekeeping_canseebillrates:
    '44eaf8a5-3f66-4111-8db1-8a965481c49a',
  employee_portal_timekeeping_canseepayrates:
    '1cc6d5c4-931e-4fa0-892a-a63ae42ea558',
  employee_portal_timekeeping_correctionsauditpage:
    'b6eff7d3-73c1-4c5e-84aa-39c93b8a1427',
  employee_portal_timekeeping_correctionsauditpagecustomview:
    '247eae97-5267-489c-81db-58a886e5ae19',
  Employee_Portal_Timekeeping_createworkorder:
    'ffadb5d1-3d0b-4f33-a7e9-d25533b29890',
  Employee_Portal_Timekeeping_exportovervpapi:
    '1937f064-069f-4a24-a3f4-f1a5966a2720',
  employee_portal_timekeeping_exporttimesheetcustomview:
    'e245bb10-26b5-48ac-b5ef-393d56c8c8e7',
  employee_portal_timekeeping_exporttimesheetpage:
    '45408308-b505-4aa7-82a8-14943f0439e5',
  employee_portal_timekeeping_keytime3daysafterrofdate:
    'f52a5f21-aee3-46ef-873b-b19c83344b1e',
  Employee_Portal_Timekeeping_reallocatebetweenjobs:
    '425d9cdf-7fb7-4eba-bfeb-872d0a4bee05',
  Employee_Portal_Timekeeping_rof_watch_list_power_bi:
    '1b44ea85-0925-4bf4-a123-c655b9a22bbb',
  employee_portal_timekeeping_splittingperdiem:
    '8bcfc091-0f14-41f3-a117-633bba98df6e',
  employee_portal_timekeeping_timein_outbyemployeecustomview:
    'fda18420-68cf-4016-883a-0ae8e11c18aa',
  employee_portal_timekeeping_timein_outbyjobcustomview:
    'c077056c-8e7c-4c6f-be0b-97eb459c1317',
  employee_portal_timekeeping_timein_outpage:
    'a121ad86-6428-4ef7-bcc1-239c9d584b4f',
  employee_portal_timekeeping_timekeepingchecklist:
    'aaf7733d-fec6-444a-9ce8-282edd090025',
  employee_portal_timekeeping_timekeepingchecklistcustomview:
    '3aee7db5-6aac-4d79-b010-0ffdbe280e9c',
  employee_portal_timekeeping_timekeepingcustomview:
    '5d4debbc-06a8-4c38-b2f9-e9374e0605f9',
  employee_portal_timekeeping_timekeepingpage:
    'a3fef5bb-50d9-4360-9cf4-64078c514c58',
  employee_portal_timekeeping_timekeepingreallocation:
    '800d4cf4-8670-4b11-98dd-18bb7615c03a',
  employee_portal_timekeeping_timekeepingsearch:
    'f1e837f5-0f30-444b-8661-cc39ba418f6e',
  employee_portal_timekeeping_timekeepingsearchcustomview:
    '111111dc-3847-4439-af6c-4d4850209364',
  employee_portal_timekeeping_timesheetcustomview:
    'df439b3b-5bb3-4794-9c71-066a539afbb2',
  employee_portal_timekeeping_timesheetpage:
    '412c5605-37a4-4df1-8019-fa4e30489c77',
  employee_portal_timekeeping_validate_and_post_vp_batches:
    '47b3ec64-0550-4adf-99c1-b2fcf83c587b',
  employee_portal_ups_employee_my_jobs_nativechataccess:
    'c4b388e2-0dcb-4c25-8c20-aa2cd143d91c',
  employee_portal_work_orders_workorderscustomview:
    '9282ffee-c7ee-4959-a311-fde3fed4dfa7',
  employee_portal_work_orders_workorderspage:
    '7c4c62e7-15f3-4b36-ac32-5b9b4c551d32',
  employeeportal_analytics_map_analytics:
    '47a7a5c7-41f8-4725-97cc-e7a16e6d63f8',
  employeeportal_availablejobsrecruiter_requisition:
    '0fa70f6b-68e6-4445-bc03-636838d53acc',
  employeeportal_badgeclerkdashboard_badgeclerkcustomview:
    'f8dade08-a531-4a7d-bc5b-5dac831b4106',
  employeeportal_classadministration_classadministrationdashboard:
    'e3094b26-f70e-4e46-b42c-04602ff11a88',
  employeeportal_classmanagement_classmanagementdashboard:
    'ea1e4372-454c-4d10-89ac-2daeba8f7aee',
  employeeportal_compliancedashboard_addresschangerequesttab:
    '7c8545c0-930e-4124-8b57-38c69d666770',
  employeeportal_compliancedashboard_compliancecustomview:
    'a7d3910f-dfc1-4ca6-af5e-3718f3b3f294',
  employeeportal_compliancedashboard_complianceworkload:
    '60f4300a-80d6-40e8-bc01-98337cfcf07e',
  employeeportal_compliancedashboard_transferworkload:
    '615d4560-2e04-4bd6-9108-df75e202ebfc',
  employeeportal_disaroster_disarostercustomview:
    '7495e483-6394-4249-8b36-0031258a4657',
  employeeportal_disaroster_disarosterdashboard:
    '84837958-7f5c-4300-90ff-e855a4e83c37',
  employeeportal_dispatchdashboard_activestatus:
    '43766c56-a93c-43af-9e52-d890d40b06cf',
  employeeportal_dispatchdashboard_billrates:
    '11eb2310-3b72-4150-a33b-3415eb331011',
  employeeportal_dispatchdashboard_dispatchcustomview:
    'd3c1ef36-337c-4d50-bbed-6f5e47171c37',
  employeeportal_dispatchdashboard_dispatchdocs:
    'df436867-34f0-4fb8-baa6-927a2fd9ddce',
  employeeportal_dispatchdashboard_editclass_craft_prdetails:
    'a9c259a1-84c6-4e21-b712-504144f707f6',
  employeeportal_dispatchdashboard_editstartdate:
    '3ae60853-5175-418b-8197-679f87758589',
  employeeportal_dispatchdashboard_editwage:
    '8831222c-3ffa-4da1-93b6-517fde706ccd',
  employeeportal_dispatchdashboard_harddispatch:
    'be3ba390-8864-4556-9567-4a1f8842813e',
  employeeportal_dispatchdashboard_mileage:
    '3edb8b88-e6ba-4abe-811c-171e8fac6e88',
  employeeportal_dispatchdashboard_multiedit:
    '40119dca-3eb1-495e-a41e-c1be6130da65',
  employeeportal_dispatchdashboard_paycolumns_non_wage:
    'd332180f-12ca-4a97-ac94-06590db376cc',
  employeeportal_dispatchdashboard_perdiemdocs:
    '0da79dc0-07e7-4c88-bc09-70be2dc8c403',
  employeeportal_dispatchdashboard_rofdate:
    '4e695061-c50a-48e7-b90c-8e83a67300eb',
  employeeportal_dispatchstatus_basicedit:
    '3ce951e7-31d2-4f0f-8560-62ae4f31f674',
  employeeportal_dispatchstatus_changecautionstatus:
    'e04d2119-be90-4261-9ead-dab82b73c02f',
  employeeportal_dispatchstatus_changedispatchedstatus:
    'c9e8cbe5-4f0d-48ec-8843-c403ef75b549',
  employeeportal_dispatchstatus_savedeclinedfromhold:
    '1f8f75c2-c1a3-4d24-a297-6eaab2415ddf',
  employeeportal_dispatchstatus_savedeclinedfromrequested:
    '0618c062-a9ac-424f-b3ce-3df5946c11e7',
  employeeportal_dispatchstatus_savedeclinedfromwrongnumberlisted:
    '1db8db5b-0a56-4936-bb9a-8a83bb96a102',
  employeeportal_dispatchstatus_saveholdfromrequested:
    'c52df092-c9e9-4020-ba90-322bb19b1e31',
  employeeportal_dispatchstatus_savepositioncanceledfromhold:
    'd40ade1b-1a2f-4a19-971a-3e6ad47a773b',
  employeeportal_dispatchstatus_saverequestedfromhold:
    '963b699d-7b0b-4a0c-9322-f0fbc5c7e20e',
  employeeportal_dispatchstatus_saverequestedfrompositioncanceled:
    'a9e36455-4e10-4dd1-98f7-0f2eeff4a7ee',
  employeeportal_dispatchstatus_saverequestedfromwrongnumberlisted:
    'c91b6a1a-aab6-4f9e-b6c2-002a283d7a15',
  employeeportal_documentmanagement_documentinfo:
    '3b104190-23ab-41ce-a4ab-bdf1502dda6b',
  employeeportal_employeejobslist_requisition:
    '84136cfb-00a1-48f9-997e-6a4bde418da9',
  employeeportal_employeeprofile_absorbtab:
    '5db877f8-6134-4842-95b0-fdf78541586f',
  employeeportal_employeeprofile_attachmentstab:
    '3cc0fdb7-1a49-4a1a-8e71-79c467b753d2',
  employeeportal_employeeprofile_authenticationdata:
    'd3b68d07-c883-44e9-b5c8-18c2ba95e6a6',
  employeeportal_employeeprofile_backgroundtab:
    '3d7405f6-6050-4ff2-8b0f-ee9c489fa952',
  employeeportal_employeeprofile_backgroundtabattachments_addresstrace:
    '36776953-4d84-489e-a0fb-2166696bd13d',
  employeeportal_employeeprofile_backgroundtabattachments_canview:
    'a07aefe6-553f-45c3-a496-2af29533b65f',
  employeeportal_employeeprofile_benefitstab:
    'bb13a993-78ea-4564-8715-03358f53e7f7',
  employeeportal_employeeprofile_benefitstab_employeetype_jobcategory:
    'e8495c54-1a55-4e33-9577-018b5dd4f743',
  employeeportal_employeeprofile_certtab:
    '3d4729e7-4d64-47c8-9344-6c022441a575',
  employeeportal_employeeprofile_chatlogstab:
    '5fb85dca-f07a-4ab0-b6f4-ea8ed48671a1',
  employeeportal_employeeprofile_editemail:
    '0c28c43b-be9b-4a55-8800-4258b422a1af',
  employeeportal_employeeprofile_emergencycontactstab:
    '2a53d1ea-27f4-4163-84e0-a7b2ed3e880f',
  employeeportal_employeeprofile_employeecustomview:
    '4aa607b7-2024-4b44-ae01-40015b5ab8c5',
  employeeportal_employeeprofile_employeeinfo:
    'd7434746-d639-4235-a0f0-773f9fb0e32c',
  employeeportal_employeeprofile_employeepacketdocumentstab:
    '978c132c-846f-4178-aea4-a2bfacb1af27',
  employeeportal_employeeprofile_employeeprofilehrref:
    'ac38d465-90c2-495c-9fa6-478b005a3330',
  employeeportal_employeeprofile_employeestab_ssncolumn:
    '26173290-d364-4ba6-8252-3a8d465715e0',
  employeeportal_employeeprofile_employmenttab:
    'ce114872-e24e-4c61-be07-41ba2e94194b',
  employeeportal_employeeprofile_employmenttab_donotrehire:
    '1957c780-ccb2-4a92-b401-43f56209cba4',
  employeeportal_employeeprofile_evaluationstab:
    '0ae3e232-48ad-429c-879b-a29996265248',
  employeeportal_employeeprofile_fittab: 'a231b66b-80be-419a-b487-168dccc92100',
  employeeportal_employeeprofile_i9status:
    'ef4ad7fd-d2a5-43ee-9f4c-a46708731d61',
  employeeportal_employeeprofile_identificationdocumentstab:
    '3d5cfc0b-6cb3-4e59-a534-5e636e276a4a',
  employeeportal_employeeprofile_identificationdocumentstab_attachments:
    '7250027c-01d1-42bf-9ec8-72b11a926992',
  employeeportal_employeeprofile_infotab:
    '1315a0ab-0bc5-46cf-a8a2-d763fb6f45c1',
  employeeportal_employeeprofile_infotab_editcellphoneonly:
    '6bce8c23-8d0b-417f-8a33-88c845544a9c',
  employeeportal_employeeprofile_jobhistorytab:
    '9dc6a615-a9fe-43ad-810b-893064477af9',
  employeeportal_employeeprofile_manpowerreqhistorytab:
    '353ba3f0-085f-43db-8b90-f2248a87db27',
  employeeportal_employeeprofile_packetdocumentsview:
    '4f545685-fa50-4bf0-9f6e-d479b3bc49c5',
  employeeportal_employeeprofile_paystubstab:
    '29bfdc65-886b-4658-8658-a2ec6649d866',
  employeeportal_employeeprofile_perdiemdocumentstab:
    '112b8c67-35d1-4a00-b0c6-49ec65454b70',
  employeeportal_employeeprofile_positiontab:
    'aa382429-7363-416e-9de8-b91de66aaf42',
  employeeportal_employeeprofile_rehirestatus:
    '110c5847-7432-4cbf-91f0-7cee0a54feaa',
  employeeportal_employeeprofile_rehirestatus_medicalreleaserequired:
    '99fb5a4c-ed87-49ed-b83e-88c27678811d',
  employeeportal_employeeprofile_roftab: 'b599f3c6-7567-49ad-904c-5b41e730aea9',
  employeeportal_employeeprofile_safetytab:
    'b697bec1-9df6-44fc-9aa2-53d9c452d61c',
  employeeportal_hrresources_hrresourcesdashboard:
    'f74db5e1-b1fc-41af-9dec-0919ffe05b24',
  employeeportal_jobrequirements_adminapprove:
    'd46ed4f3-898b-4ef5-a42c-72d9f48a0975',
  employeeportal_jobrequirements_jobrequirementscustomview:
    '8c3662fc-50d4-49f6-b46c-289382ada8fc',
  employeeportal_jobrequirements_jobrequirementsdashboard:
    '2bd2b315-30b7-4dde-8885-ba12d0bbedb3',
  employeeportal_lodging_lodgingadministration:
    '7c081d5e-82a4-4f47-b9b4-39184fb7525a',
  employeeportal_lodging_lodgingcustomview:
    'b6f4a803-6e29-4f40-824f-4922c28507ec',
  employeeportal_lodging_lodginggrid: 'f27f439d-96e8-4373-845e-98cbfb809c46',
  employeeportal_lodging_lodingandeventsapi:
    '4faa0a29-8d56-4935-90fb-df4401c2d579',
  employeeportal_manpowerpopup_allowdispatchof6monthormoreofinactivity:
    '17a5d498-75f6-40e9-bf8e-8d5dcb6f96d9',
  employeeportal_manpowerpopup_assignnonrehirable:
    '7c0e1e41-2188-4e4c-b25a-0aaea2ecfb43',
  employeeportal_manpowerpopup_employeenotes:
    '34c1be7a-6dc9-41ed-a5e0-9428f1952eaa',
  employeeportal_manpowerpopup_forcedispatch:
    'c5957c33-c59f-40bd-9454-1ebc675e7c9c',
  employeeportal_manpowerpopup_jobrequirements:
    '8dabca72-751d-46fe-996b-878260424e97',
  employeeportal_my_ups_hrfiles: '33e5096d-eca8-4218-9f3b-d0cd9abd627a',
  employeeportal_navigation_canseeavailablejobsrecruiter:
    '245cbf8b-4cab-40ac-a5d8-4ec8d118cbf9',
  employeeportal_navigation_canseebadgeclerkdashboard:
    '196a28ce-0a0f-44ce-9935-1e062d0b33d7',
  employeeportal_navigation_canseeclassadministration:
    '79d411c0-1e7f-44aa-a61a-0ec90416931c',
  employeeportal_navigation_canseeclassmanagement:
    '2e735857-0820-4363-a8f0-aff1155ad08c',
  employeeportal_navigation_canseecompliancedashboard:
    '72e6c6c2-c9d1-4da2-bb1f-36cfd9c862ae',
  employeeportal_navigation_canseedisaroster:
    '128d5b6b-5011-4da7-8d3c-8a26c8a284b7',
  employeeportal_navigation_canseedisptachdashboard:
    '5c29a753-ac43-41b9-9f4e-f8d5481b2fb1',
  employeeportal_navigation_canseeemployeejobslist:
    '177828aa-07d1-47aa-b05f-421dbf35f02d',
  employeeportal_navigation_canseeemployees:
    'f930dbd4-b202-4b8d-9647-9f9215688b69',
  employeeportal_navigation_canseemyprofileinfotab:
    '4eb7e2db-016d-4761-8a73-7d16f75a335c',
  employeeportal_navigation_canseeperdiemauditdashboard:
    '88f80148-68eb-446c-a6d5-81d584e5ab75',
  employeeportal_navigation_canseeprojectmanagerdashboard:
    'aec5595d-8ff8-4809-b9b4-1853b0333a98',
  employeeportal_navigation_canseeprospects:
    '26f8d0f0-d382-415a-8b21-4f74c3ac4ba1',
  employeeportal_navigation_canseerecruiterdashboard:
    'e0bc7dd2-f3f2-4d58-a1ba-a60cf26c05cc',
  employeeportal_parentcustomers_parentcustomersdashboard:
    'da426305-9aca-42df-ba69-97645c6f6afa',
  employeeportal_parentfacilities_parentfacilitiescustomview:
    'b60150fe-588a-4e8c-a994-26ec6c881597',
  employeeportal_parentfacilities_parentfacilitiesdashboard:
    '88902048-fde9-4d4b-a336-341f9e8d3237',
  employeeportal_perdiemaudit_generatewithoutapproval:
    'b57c99d4-d17e-44ed-bb2d-c0bc078e58e5',
  employeeportal_perdiemaudit_jobpopup: '2ea08966-55b8-48dc-891b-b19efa89437c',
  employeeportal_perdiemaudit_perdiemapproval:
    '802fc251-18c0-4431-9d39-ccf342b6f5a1',
  employeeportal_perdiemaudit_perdiemcustomview:
    '398f5208-8c2f-43a1-a100-d97adb7a3ffe',
  employeeportal_plants_plantscustomview:
    '961fe424-c7e7-4c82-8f61-e24d67a6f2dc',
  employeeportal_plants_plantsdashboard: '053c20c5-477d-421d-96cd-01b4f0a445a2',
  employeeportal_projectmanagerdashboard_projectmanageradvance:
    '9a496878-416b-4863-9006-24a41f8cb82b',
  employeeportal_projectmanagerdashboard_projectmanagercustomview:
    'a0780247-d98f-4ed8-b624-dc1c973d79de',
  employeeportal_projectmanagerdashboard_projectmanagerdashboardinfo:
    'f9e09c14-0c0b-4467-a29a-8796de54c944',
  employeeportal_projectmanagerdashboard_projectmanagerequipmentcustomview:
    'eaee380e-ec5c-4fa8-802d-c2c2f485408a',
  employeeportal_prospectivejobs_prospectivejobscustomview:
    'a532c364-e88e-4b19-8332-8862cad2c174',
  employeeportal_prospectivejobs_prospectivejobsdashboard:
    '093fc505-97f1-470b-b4c1-357c41f51651',
  employeeportal_prospects_packetregistration:
    '32b8caf8-6d3c-4953-8433-741971eed6f6',
  employeeportal_prospects_prospectinfo: '92bf9b3d-94f1-404f-a550-fff3c489f132',
  employeeportal_prospects_prospectscustomview:
    'c55acbb5-f867-4721-8beb-214b50f7b12b',
  employeeportal_recruiterdashboard_bulkeditrecruiter:
    '3e8aa3ff-09fb-4cf3-bfca-7026dda6c6fb',
  employeeportal_recruiterdashboard_recruitercustomview:
    'df3e5b0d-2e97-4d03-95c8-25e373f4d168',
  employeeportal_recruiterdashboard_recruiterscorecard:
    'cf69d556-fdb6-49ae-bb6f-3c072301c054',
  employeeportal_recruiterdashboard_recruiterworkload:
    '623e1ccc-d1ae-4708-8fbf-a60b412f5859',
  employeeportal_recruiterdashboard_transferworkload:
    '64874bc8-4acd-4532-9939-894f22307bdf',
  employeeportal_upsemployeemyjobs_employeejobs:
    'ef15fdfd-3222-4c44-a9c7-f21f31e93ff3',
  employeeportal_zipwhip_chatlogs: 'c4e3e684-0c69-4000-b6a9-67a2bfda4e09',
  foreman_time_entry: 'adc5f3a9-57f9-411a-a252-2b5f7ed92e2a',
  Foreman_Toolbox_Application_Access_basicaccess:
    '4fa4fe12-58a5-4333-9e3a-34a13d44fd0e',
  Foreman_Toolbox_Ask_Ryn__foreman_Toolbox_ask_ryn:
    'd347d0f8-241a-4b9e-8ac2-cf67a964dcc1',
  foreman_toolbox_badge_kiosk_badge_in_out_kiosk:
    'a1e61265-7606-487e-a1a4-aff1324e0287',
  geocode_admin: '0e42ec5f-e072-49bb-9c2a-3f4bd694851a',
  HR_Packet_HR_Admin_auditlog: 'd93d075f-6a69-4a14-84cf-97367b44c431',
  HR_Packet_HR_Admin_companies: 'b99482da-3caf-41d6-9cad-739c16af20e9',
  HR_Packet_HR_Admin_formtemplates: 'cf032b6d-d057-44bf-bcb0-6360bc5001ac',
  HR_Packet_HR_Admin_jobsdashboard: '79b09299-c668-4fb2-a611-fd64a4f79880',
  HR_Packet_HR_Admin_manageusers: '3e8083ae-f144-43dc-b3ca-6da9fd3f2a72',
  HR_Packet_HR_Admin_senddocstore_sign: '2c02096d-cf8d-4e2e-8094-3f3c07c41789',
  HR_Packet_HR_export: 'b14eee06-1c0e-4d10-94df-e35387a88fc4',
  HR_Packet_HR_hredit: 'b38a14b4-9222-4e51-ae00-0005294c77f0',
  HR_Packet_HR_i_9management: '7d48aba1-d35d-4e8a-8fcc-b5dd5625d12b',
  HR_Packet_HR_lookuppackets: '104aed04-fffc-4d1b-86ea-62ea1fd7d1dd',
  HR_Packet_HR_onboardingdashboard: '8685acce-ee82-41bc-8217-f68be6715819',
  Hse_Toolbox_Mobile_Ask_Ryn__hse_Toolbox_Mobile_ask_ryn:
    'c4d7fff1-2f59-419d-a1c2-c7981f255f18',
  individual_time_entry: 'ea2216eb-f48f-4162-999e-85532311be11',
  it_portal_budget_view: 'b1206670-525f-4ae1-babc-9a074aa8a35b',
  it_portal_employee_assets_view: '64b85acc-f823-45ff-8b7e-a79e0bedceee',
  it_portal_improvement_ideas_edit: '71730ffe-efd4-4dc4-819a-b6f602ecd1ee',
  it_portal_roadmap_view: '6ced190d-5bc9-47bd-85f0-207f555bf18f',
  it_portal_seat_override_edit: '4b25b9c5-0951-4bd8-a9af-e23a3be5e5c9',
  My_Ups_Mobile_Ask_Ryn__my_Ups_Mobile_ask_ryn:
    '1de11bf3-2047-4787-87b6-378827618fe5',
  My_Ups_Mobile_Performance_Reviews__my_Ups_Mobile_employee_performance_review:
    '4c508271-2f87-44db-a0bf-0b3b2f2b3575',
  My_UPS_Web_Ask_Ryn_ask_ryn: 'ab4c64c8-54eb-4778-90d1-81a2702ff28c',
  my_ups_web_performance_reviews_employee_performance_review:
    '6ff6a180-897e-4ff8-b13f-9c02adf6d64f',
  my_ups_web_performance_reviews_hr_operations:
    '83449eb2-e023-4257-93f6-b17462280dd9',
  NIFTY_Backorders_backorderspage: '46abacba-1a5d-450c-b26a-cc87dc747666',
  NIFTY_Customers_customerspage: '50cf867d-db01-4444-82da-1a08373564f5',
  NIFTY_Diagrams_diagrampage: '62cb3d92-3f8b-420f-ba52-26a9023df6d5',
  nifty_dock_log_docklogcustomviews: 'ee464831-427f-4371-a43d-cbfef9fff64b',
  Nifty_Engine_Knowledge_view: 'b6e6e79e-0f44-49f8-87af-f71721b69fe2',
  nifty_inventory_add_editsublocation: '00e23279-ab4f-45f2-8ac4-0511955760b9',
  NIFTY_Inventory_canseeprices: '7b51f32c-3eb3-4ce3-97a9-b6e3840683d0',
  Nifty_Inventory_dashboard_page: '1de05a2e-a5bf-44dc-90cc-a437039b5638',
  NIFTY_Inventory_inventoryhistory: '1b6b27bc-6c6b-46e5-a5b8-b76ec0cee44a',
  NIFTY_Inventory_inventorypage: '366138f8-8b5d-4366-973a-33872285772d',
  NIFTY_Inventory_materialnotes: 'ce2876e6-d827-493d-a415-3da285d22009',
  Nifty_Inventory_vendor_purchase_history:
    'a44c9108-f956-402c-bffa-c6d30d7a919b',
  NIFTY_Label_Maker_createsublocations: '5459686f-5c36-41f9-8720-33eff93b94af',
  NIFTY_Label_Maker_labelmakerpage: '605cfa4d-2899-4c84-b8b5-fec348169cc6',
  nifty_materials_management_docklogpage:
    '15160e1a-865f-4425-b3c4-12ccad4e27be',
  nifty_mobile_inventory_inventorymanagement:
    '85de2587-d410-4545-a3b1-724f92cd8425',
  nifty_mobile_inventory_damaged_shipment:
    'ca293165-18f5-4d47-9571-bae1946afffb',
  nifty_mobile_inventory_materialphotos: '1a5f071f-be02-42dd-a61e-07f1e728ee5a',
  nifty_mobile_inventory_transferstockandprint:
    '98a575d8-68fb-4a99-8e1c-6bc5f693036d',
  nifty_orders_createquote: '07e48d03-10bc-4027-8ae9-8f5de7f8f480',
  nifty_orders_editorder: 'ef504702-c2f3-4819-b847-a24c99ba69c3',
  nifty_orders_fulfill: 'c2a984c4-b174-4814-bb29-123407ea1980',
  NIFTY_Orders_orderpage: 'f09a59c0-48f1-47a2-8acc-09ccef81e649',
  nifty_orders_quotetosalesorder: '4959c913-fd5e-41c2-9325-fa8e9b4597b3',
  NIFTY_PowerBI_allreports: 'e7963bf2-a23c-465c-bf8a-200cb98893c3',
  NIFTY_Shared_materialvpupdatemodal: '83f09308-64ef-4c12-9052-cb3735ed8726',
  NIFTY_Vendors_vendorpage: '1790923d-c2d9-498d-b604-955ff2ff391c',
  Operations_Management_Accounts_accounts_page1:
    '9f27d14a-12f7-4a8a-af49-8a65c4465a89',
  Operations_Management_Accounts_accountspage:
    '8f2cffc4-78f0-47d3-8b66-eaca65e46b86',
  Operations_Management_Ask_Ryn_ask_ryn: 'dee92528-0489-4d49-9d94-982f86bf93bc',
  Operations_Management_Bd_Team_bd_activity_dashboard:
    'be728787-c6cc-4794-9539-13fea25c2f28',
  Operations_Management_BD_Team_viewbdteampage:
    '73772909-82ed-44ee-96fa-c9cbda965e90',
  operations_management_contact_page: '47787ac8-8a6a-4462-aae2-43849186ed18',
  Operations_Management_Estimate_Builder_estimate_builder_admin:
    '97c49f7c-2d65-4f4c-9988-daddc4a833f2',
  Operations_Management_Estimate_Builder_estimate_builder_page:
    '9160fe38-70a2-4b3e-b8c6-c671e1cd3ceb',
  Operations_Management_Fleet_fleetpage: '17456b1a-f340-4143-8a29-65a2c69d4f93',
  Operations_Management_Jobs_jobspage: '063db9b1-a2a0-4674-b03e-9bebb2f4547a',
  Operations_Management_Manpower_Needs_manpowerneedspage:
    '2a11cfa4-4722-4c4b-976a-e1dfe1f59746',
  operations_management_navigation_quotelogpage:
    'f995ad13-010c-443a-8ecb-4cefe824d8eb',
  Operations_Management_Opportunities_activities:
    'e7bd82c3-3443-4af0-93fd-8dd09a1b2b0f',
  Operations_Management_Opportunities_customreport:
    '356bbc8c-c084-4cf8-878b-a6293cceb56f',
  Operations_Management_Opportunities_forecastlock:
    '03509b2a-0fcf-43d3-a363-5d56526581ae',
  operations_management_opportunities_leads_map:
    'f8c94216-4660-4443-8971-c784ce5c8853',
  Operations_Management_Opportunities_opportunitiesdashboardpage:
    '1e9cccd3-de11-42fb-8f84-d7310b1f11ce',
  Operations_Management_Opportunities_oppotunitiespage:
    'e80268ec-f39c-46d8-a8e3-1ec854af9346',
  Operations_Management_Opportunities_reportspage:
    '90230e6a-0798-44a6-bf60-85fec8367bf0',
  operations_management_ops_mgt_admin_glossary_edit:
    '6b2a81a1-ce88-4041-8180-6affde4ef74f',
  operations_management_ops_mgt_admin_sales_targets_edit:
    'b2efda5e-76e9-4a73-8213-c735a0c13b02',
  // US 35765: UX default only, NOT access control. Granted to the OM "Business Development" role; the
  // Opportunity Log opens on the public "BD Rep" view for users with it (until they pick another view).
  operations_management_quote_log_page_bdrepdefaultview:
    'd1d06ba4-d01c-494a-8655-249bbe474120',
  operations_management_quote_log_page_bidreviewdate:
    'de929645-0322-4f18-acf1-134c30ff4909',
  operations_management_quote_log_page_createquote:
    'a3f1e9a8-ab09-4b05-87b9-d2040c593b72',
  operations_management_quote_log_page_editdeadquote:
    'c2687395-7719-4c1b-9740-033429cd2a56',
  operations_management_quote_log_page_editquote:
    '4c4a6112-797e-4c70-8fc1-a600b51ab022',
  operations_management_quote_log_page_exporttoexcel:
    '784e7ec7-e3cb-4271-808a-f591f33bbe42',
  operations_management_quote_log_page_gridcustomview:
    '219dcf76-5510-41d0-a192-8982531d5ac3',
  operations_management_quote_log_page_quotelogattachments:
    '9a87e7d9-38c4-4714-8b46-f3fa58c40509',
  operations_management_quote_log_page_quotelogattachmentsdelete:
    'fe4191f1-ea1b-4231-aa54-dfb87d444f19',
  operations_management_quote_log_page_quotelogrevisions:
    '7118595e-8507-4fa7-9235-5093bebddff8',
  Operations_Management_Quote_Log_Power_BI_quotelogallreports:
    'e4b256c4-bf28-4c5a-8ff3-5c10eedec072',
  Operations_Management_Revenue_Stream_revenuestreampage:
    'c8679b0f-d095-4204-8c38-0e22f1ac2889',
  Operations_Management_Service_Request_alwaysseeplantdropdown:
    '9e2efd3b-202c-48fd-9126-3fa8a905ecee',
  Operations_Management_Service_Request_approver:
    'bca07a16-c940-4d1d-97f9-d05235422ed1',
  Operations_Management_Service_Request_companyscopeoverride:
    '37382a6b-6f35-4c23-895a-d583e9424125',
  Operations_Management_Service_Request_convertquotetosrfjob:
    'a3fcc1f4-4ace-45f2-8aac-eb0899790d3a',
  Operations_Management_Service_Request_convertsrfjobtojob:
    '5c418dee-1e01-4d14-92ee-73ea20a9e231',
  Operations_Management_Service_Request_convertsrfquotetoquote:
    'ace2af75-a622-4404-a3b3-d611ede72c89',
  operations_management_service_request_forecast_category:
    '64c0aa7b-5fb7-4a93-90eb-747c19bcebff',
  Operations_Management_Service_Request_prospect_approve_conversion:
    '0cdacbb9-a464-4cf2-bb79-d124e7a41e59',
  Operations_Management_Service_Request_srf_vp_job_create_gate:
    '672c7534-7ab4-4c2b-bb82-a6d003c430f9',
  Operations_Management_Service_Request_srfnotificationadmin:
    '510cbc0a-a675-4d2c-8511-5727f6f343c6',
  Operations_Management_Service_Request_viewservicerequest:
    '46ead6f5-37d8-4256-9551-b1ff0cc5d3f6',
  Operations_Management_Sync_Tools_omwebjobintegration:
    '2e8ab756-ef5d-44b0-8bc0-54635f76c324',
  Rates_Management_Admin_baserevenuecodes:
    '42121ea4-c1e0-48be-90ea-1ed6e375135a',
  rates_management_admin_contractsections:
    'f49f0565-f6f6-4e47-b00b-02863ad010aa',
  rates_management_admin_divisions: 'cea6eb95-bb41-4564-9700-60bc316d25b6',
  rates_management_admin_equipment: '875f807f-8233-4686-95fc-9b458ee5302c',
  rates_management_admin_equipmentnotes: 'f07287c0-f442-4035-bac1-c0d2ab267f73',
  rates_management_admin_revenuecodes: '1755df0c-1331-4117-84ed-7dda007f24fd',
  rates_management_admin_unitsofmeasure: '9339db30-bafa-4077-b6a5-cd7cf2a0f022',
  rates_management_contracts_contractattachments:
    '23bfbc5a-68ec-4154-a60f-92228021cc2b',
  rates_management_contracts_contractscreen:
    'df8e33da-7bb8-427f-911f-0c5a6442c127',
  rates_management_contracts_contractsummary:
    '569b578f-c65c-4a7f-8385-a348ab25f7ec',
  rates_management_contracts_copycontracts:
    '54cf86a2-8b5a-4edd-9867-5cdf5ccf06db',
  rates_management_contracts_createcontractscustomviews:
    '05c08b0b-bee4-44b9-bfe5-32af74c3afdb',
  rates_management_devtools_jsonviewer: 'bb52f0cd-5ccc-4461-abaf-50ff9204916f',
  rates_management_rate_sheet_editequipmentbaserevcodes:
    '898b7f8b-5030-4774-90e6-d768f3e0ce11',
  Rates_Management_Rate_Sheet_equipmentrevcodecolumnvisibilitytoggle:
    'd7924641-9222-497f-8b55-8a8399d29fd5',
  rates_management_rate_sheet_ratesheetattachments:
    'b1191b25-4af8-42d4-928b-69b83811806d',
  rates_management_rate_sheet_ratesheets:
    '8d0bbd20-9b80-4b3a-87c8-35ce95a072ea',
  rates_management_rate_sheet_versionratesheets:
    'beb9fd7f-f77f-4a67-a34e-2626b40af9bd',
  rates_management_rates_app_navigation_contractselectionscreen:
    'dc04bd41-b3a1-492c-ba87-b6995126b10e',
  rates_management_rates_app_navigation_ratesheetclassification:
    'bcfe8cbb-85ce-4d5c-80b5-330b3cb42c0f',
  rates_management_rates_app_navigation_ratesheetcustomcolumns:
    '9961f0c2-2476-4839-8a3d-3adebd7f62ae',
  rates_management_rates_app_navigation_ratesheetequipmentrates:
    '7dace562-e055-4fe0-949a-0a048297b9c1',
  rates_management_rates_app_navigation_ratesheetselection:
    '624531a9-0284-41fe-8c5b-5cf9cc01d8e3',
  rates_management_rates_app_navigation_ratesheetterms:
    'b6358fb1-8454-48c9-bc22-24da3b5e38d7',
  rates_management_rates_app_navigation_wagesheetcustomcolumns:
    '7236a360-bad6-4aa4-8109-e5c31c43ce92',
  rates_management_rates_app_navigation_wagesheetdataentrypage:
    'f723ccb6-4b26-454e-b79c-65534dfdb113',
  rates_management_rates_app_navigation_wagesheetselection:
    '3cee13aa-9905-42ce-a1ff-ae7b414da383',
  rates_management_rates_app_navigation_wagesheetterms:
    '7e01331d-ad78-4fe3-b0a2-7060c7148e61',
  rates_management_rates_management_reports_lrcsreport:
    'ed87133e-805f-417c-a27a-ad7a5eeaefc7',
  rates_management_wage_sheet_copywagesheets:
    '3a94b81f-ce8c-4e46-806a-404e2db86bb2',
  rates_management_wage_sheet_versionwagesheets:
    'adbbf3ab-40a1-47b5-8aed-05db88aa48ca',
  rates_management_wage_sheet_wagesheets:
    '38bbdbde-3d72-4ac2-8e4d-57c57b673788',
  Resource_Allocation_Ask_Ryn_ask_ryn: '0e0e8de7-0627-4478-bd81-ed940b44bda2',
  resource_allocation_class_administration_ra_classadministrationdashboard:
    'be184318-759b-42be-a74f-72808b19a362',
  Resource_Allocation_DevToolsRA_jsonviewerra:
    'a060b9d8-b16c-4583-802b-757a799530a7',
  resource_allocation_dispatch_dashboard_ra_mileagemultiedit:
    '0bbde1df-108d-4679-a6ab-2be690f1940f',
  resource_allocation_employee_absorb_tab_prefilterskillandonboardingcourses:
    'c411345f-479f-4316-b296-e245bcd8463d',
  resource_allocation_employee_expertise_employeeexpertise:
    '67b47c42-3c55-47e5-8a56-dfd99c81daba',
  resource_allocation_employee_expertise_equipmentexpertise:
    'b25c71af-7ff5-4aa2-9db1-2927139b43f7',
  resource_allocation_employee_expertise_manpowerreqdetailexpertise:
    '3f56f47f-7b01-4e77-83e6-31532391fea2',
  resource_allocation_employee_expertise_performanceevaluation:
    '90b97697-c40e-42d2-aa34-4cfbb08a3d55',
  resource_allocation_employee_expertise_tradeexpertise:
    'ae3d1507-cecd-4110-88a5-8efdaf93dd09',
  resource_allocation_employee_profile_ra_allowuseofalive5forchatlogs:
    '14a37b70-2863-4ba8-bb50-2ae020543615',
  Resource_Allocation_Employee_Profile_Ra_fleet_documents:
    '5a94c97f-ec4a-4858-afee-5c8b025a74ad',
  resource_allocation_inventory_count_additemstocount:
    'e8e5fd64-16c9-4cc2-888d-46d946e5b85b',
  resource_allocation_inventory_count_adjustbillable:
    'ed40f93a-2447-4839-85a4-b0971b436aa9',
  resource_allocation_inventory_count_adjustcountadjusted:
    '563f4264-ca28-484b-aa63-c0d2b9c971ac',
  resource_allocation_inventory_count_adjustcountrecommendedinventorylevel:
    'fcddb565-e240-47f2-9e16-b974facc761e',
  resource_allocation_inventory_count_adjustinitialcount:
    '6846e36a-aa60-4680-b421-d18e017b08cf',
  resource_allocation_inventory_count_adjustorderedandreceived:
    'c2d60338-cd0b-433f-b236-dbb880726a84',
  resource_allocation_inventory_count_adjustpulled:
    '7777f3c6-80c1-40c3-9038-8984ac2e2765',
  Resource_Allocation_Inventory_Count_admincount:
    '6bdb6845-b9b5-4178-b789-469993ddabc1',
  resource_allocation_inventory_count_canaccessmobileapp:
    'cae48cd3-6e25-4010-b7cd-d5b9445f0f4b',
  resource_allocation_inventory_count_createnewcount:
    '0c61d785-0995-4068-b7d6-88f54c9b5cda',
  resource_allocation_inventory_count_equipmentselection:
    '8564f18d-43c5-4d0c-b218-8bc5fe38dd59',
  resource_allocation_inventory_count_inventorycountcustomview:
    'b0cc3236-1140-44ce-ae53-713877af10e3',
  resource_allocation_inventory_count_removeitemsfromcount:
    '01f7679e-6351-447e-a394-85be4b488283',
  resource_allocation_inventory_count_serialnumberandexpirationdate:
    '3e9a2ca8-6efd-45e9-8245-86c87622cbe0',
  resource_allocation_inventory_count_status_change_demobilizeapprovedtoclosed:
    '13cf81e2-679d-44d2-ba66-a0e667b3853a',
  resource_allocation_inventory_count_status_change_demobilizeopenfromdemobilizepullorreturn:
    'cb240d0d-62bc-4c2b-8162-122c41959f8e',
  resource_allocation_inventory_count_status_change_demobilizeopentodemobilizepullorreturn:
    '37724b7b-5965-436e-bad2-957143a9f4ae',
  resource_allocation_inventory_count_status_change_demobilizependingfromdemobilizeapproved:
    'fce95c64-619f-44e0-89f0-665163a46e0f',
  resource_allocation_inventory_count_status_change_demobilizependingtodemobilizeapproved:
    'f4374f87-fbea-4fe0-919d-5b519844836b',
  resource_allocation_inventory_count_status_change_demobilizepullorreturnfromdemobilizepending:
    'eb61398d-0619-46a3-8afe-762b959c1b24',
  resource_allocation_inventory_count_status_change_demobilizepullorreturntodemobilizepending:
    '000a4530-79b9-42de-906a-619f2eb15d61',
  resource_allocation_inventory_count_status_change_fieldcountfinalclosefromdemobilizeopen:
    'f5d3e200-94c6-454e-9dc1-b3f4b21b4f39',
  resource_allocation_inventory_count_status_change_fieldcountfinalclosetodemobilizeopen:
    '5754d38a-0e85-4dea-bc9a-359732a489a2',
  resource_allocation_inventory_count_status_change_fieldcountfinalopenfromfieldcountfinalclose:
    '12453f72-1e11-49d9-ae16-8458db7a07b9',
  resource_allocation_inventory_count_status_change_fieldcountfinalopentofieldcountfinalclose:
    'fc7baa18-368b-4b13-a2a3-c20731e4d4f3',
  resource_allocation_inventory_count_status_change_fieldcountinitialclosefromfieldcountfinalopen:
    'ba13f939-aab5-4336-b16b-b6e05688bf9a',
  resource_allocation_inventory_count_status_change_fieldcountinitialclosetofieldcountfinalopen:
    '8e43a0e8-d28a-48fe-8359-0feace0b97eb',
  resource_allocation_inventory_count_status_change_fieldcountinitialopenfromfieldcountinitialclose:
    '37f27d21-f70d-4914-b46c-1cfd4b2307b6',
  resource_allocation_inventory_count_status_change_fieldcountinitialopentofieldcountinitialclose:
    '005e1f4b-7e2a-48d4-a90a-f827a410ae22',
  resource_allocation_inventory_count_status_change_mobileopenfrommobilepullorreturn:
    '3da6b694-ada8-4673-928e-9624be656560',
  resource_allocation_inventory_count_status_change_mobileopentomobilepullorreturn:
    'df633c68-bdb5-4b2d-9c51-8ffc5385f7fe',
  resource_allocation_inventory_count_status_change_mobilizeapprovedfromfieldcountinitialopen:
    'd762c67b-231e-4737-aa15-04c2ffc24a7c',
  resource_allocation_inventory_count_status_change_mobilizeapprovedtofieldcountinitialopen:
    '5a82131f-89aa-4bd1-9617-10b37204610d',
  resource_allocation_inventory_count_status_change_mobilizependingfrommobilizeapproved:
    'f7fb6b43-deea-429a-b0ad-afc4cd234f6f',
  resource_allocation_inventory_count_status_change_mobilizependingtomobilizeapproved:
    'c1fc982b-9523-4d13-a608-299196d5331d',
  resource_allocation_inventory_count_status_change_mobilizepullorreturnfrommobilizepending:
    '0fdb0f69-5fca-4e44-bef8-cdc0d33b6250',
  resource_allocation_inventory_count_status_change_mobilizepullorreturntomobilizepending:
    '81c2d775-a094-409a-a234-ba39b14e5aea',
  resource_allocation_inventory_properties_addtethering:
    'ecfa9d3f-ec3e-4a6e-8d6e-11f17f90b289',
  resource_allocation_inventory_properties_itemcustomview:
    '8a0e0228-2c2e-47fc-b42d-92f7a932515f',
  resource_allocation_inventory_properties_itemname:
    '1e450f4a-52e7-4996-b268-f5fe4fcac9e7',
  resource_allocation_inventory_properties_partnumber:
    '2a1e7d1b-338d-4387-9800-754857bbbf37',
  resource_allocation_inventory_properties_reminder:
    '187ef446-f8e7-4239-b1e5-2c8a3202e7b9',
  resource_allocation_inventory_properties_retire:
    '0ae7def0-1b51-4a9f-a0f9-5ba21f339347',
  resource_allocation_inventory_properties_tethering:
    '691576d7-4bd7-4ff0-a3d4-7f643e60909d',
  resource_allocation_inventory_properties_toolgroup:
    '50a55f25-b66b-4057-9277-1a79d7806594',
  resource_allocation_inventory_properties_vendormanufacturertable:
    '699576de-f4d3-44ce-8477-1635fa2ef42e',
  resource_allocation_inventory_template_addrelatedequipment:
    'e36c0916-0269-41a4-9a18-b67fcdea3a96',
  resource_allocation_inventory_template_adjustrecommendedinventorylevel:
    'be284f18-8362-41ce-8590-a7ca8bf284ff',
  resource_allocation_inventory_template_deleterelatedequipment:
    '57f0984d-a7b8-43c3-885f-50aab1efb391',
  resource_allocation_inventory_template_inventorytemplatedetails_additems:
    '6b76a9b5-f009-4262-9084-1f3c1e2139b3',
  resource_allocation_inventory_template_inventorytemplatedetails_removeitems:
    '3ecf1123-931b-4a68-9624-76a28fb32518',
  resource_allocation_inventory_template_inventorytemplateheader:
    '23e83c3e-c665-42da-96c2-fa93e3868077',
  resource_allocation_job_requirements_ra_cancopyjobrequirements:
    '3ab729ea-0459-4f61-a0c6-8fcfeaee5f25',
  resource_allocation_plants_on_resource_allocation_cancopyplants:
    'ff93cb57-d70c-4dc8-839e-6d5f8096033e',
  resource_allocation_pm_dashboard_byjobtab:
    'f43820bc-6d91-4f22-bd0e-2989506f14a4',
  resource_allocation_pm_dashboard_facilitymanpowerreport:
    'f14db4c5-e4fb-4c14-8eee-ae31f8401f36',
  resource_allocation_pm_dashboard_requestedclass:
    'bcd648a1-e900-4beb-a83e-9dbf81abe46e',
  resource_allocation_pm_dashboard_searchcandidatesformanpowerposition:
    'd01acdcd-b8e7-4a27-97e0-129bd1699258',
  Resource_Allocation_Promotion_Review_promotionreviewview:
    'bafd328d-198d-4c55-9f7f-9c6d9cbd8154',
  resource_allocation_recruiter_dashboard_ra_prospectcreationusenewprocess:
    '73e98d52-f8d0-4884-bf9d-62d3178cf5d3',
  resource_allocation_resource_allocation_navigation_containerpage:
    'de82f656-6716-4d36-916d-32fec04e1f41',
  resource_allocation_resource_allocation_navigation_inventorycountpage:
    'a4259d88-a89b-4110-8fcc-f10b9ee0a469',
  resource_allocation_resource_allocation_navigation_inventorytemplatepage:
    '62583997-4595-4603-8c0c-906f7b0e0cc6',
  resource_allocation_resource_allocation_navigation_itemlisting:
    '47f4ac9e-4d72-4aff-9f51-59bfd80d2d7d',
  resource_allocation_resource_allocation_navigation_moveitemspage:
    'c694a074-ecda-4365-95d4-65874882f951',
  Ryns_Roost_Roost_Administration_bridgelogs:
    '09ba1cb6-f019-4354-b16c-604c294d5bc4',
  Ryns_Roost_Roost_Administration_bridgeregister:
    '37975e49-45c5-43a8-9292-c0f3d1686f65',
  Ryns_Roost_Roost_Administration_dashboardinfo:
    '0c2ef28f-343a-41ba-b2d4-75b25af5244b',
  Ryns_Roost_Roost_Administration_dispatchskill:
    'e4f56740-c83f-4387-aa89-edbfd5a880ae',
  Ryns_Roost_Roost_Administration_entra_apps:
    '659a1059-2a2f-468e-9439-b7bbf8415c33',
  Ryns_Roost_Roost_Administration_flock_management:
    '530b02df-14dc-4574-91f7-ee4d3561d51a',
  Ryns_Roost_Roost_Administration_flockcontext:
    '4394de1c-bb52-4f65-8d9f-04d07059a4e8',
  Ryns_Roost_Roost_Administration_hosts: 'cf69b2ec-526d-40fd-8d63-d6cb23daef14',
  Ryns_Roost_Roost_Administration_memory:
    '164a1cb0-46bf-410a-bb73-8523038167c5',
  Ryns_Roost_Roost_Administration_people:
    '28672a6c-d531-4582-86b3-1eecebdefe89',
  Ryns_Roost_Roost_Administration_planner:
    '9b113f1e-660e-429d-99c9-5dee0d736606',
  Ryns_Roost_Roost_Administration_quota: 'e5015311-72b0-443f-8f1c-ea222e0da7a4',
  Ryns_Roost_Roost_Administration_terminals:
    '6dfaa8db-d816-4eaa-a3ae-ec0c38184e5f',
  Ryns_Roost_Roost_Administration_tokens:
    '29892d4c-7e26-4641-974b-0da0845a8bf5',
  safety_2_0_coach_forms_coachformscustomview:
    'dfa8a7bd-d4f4-409d-baa0-d911d07992fc',
  safety_2_0_coach_forms_coachformspage: 'b2ce0bc0-02cb-448e-beb8-441044d54652',
  safety_2_0_form_builder_advancedfields:
    'f8d60a48-0ee7-4ae4-8b5d-fdb4dd79c9c6',
  safety_2_0_form_builder_formbuilderpage:
    '3142ee11-52bc-40b3-8790-19c066401895',
  safety_2_0_form_controls_page_formcontrolspage:
    'fe41744b-8772-40d3-b156-c7025575376f',
  safety_2_0_form_controls_page_formcontrolspagecustomview:
    '346813e2-23af-499a-9eed-88343de4953f',
  safety_2_0_form_properties_formpropertiescustomview:
    '0b651d09-ac9a-4fbf-82bf-d1cb9d9f95d1',
  safety_2_0_form_properties_formpropertiespage:
    '7dcec9d4-2a98-461b-ab4a-13af2c963bf7',
  Safety_2_0_Forms_aireview: '0a880df3-af95-483c-a72f-ec4aee304648',
  safety_2_0_forms_approvalcomments: '924040ca-a6f3-4ee4-8996-4e950e7cb97b',
  safety_2_0_forms_canaddlessonslearned: '9c5654f6-c17a-4bd4-9421-a4bfca343887',
  safety_2_0_forms_cancoachforms: '9d19a2c5-8cca-4f27-af13-d7d91297a36c',
  safety_2_0_forms_cancommentforms: '0519f2d8-d921-4781-aff2-0f3a7993d613',
  safety_2_0_forms_caneditacceptedforms: 'e236c13e-1a3a-42e9-8907-cdbac3c5acb1',
  safety_2_0_forms_caneditforms: '1b6292d2-0713-402c-9b85-91315870005f',
  safety_2_0_forms_caneditrejectedforms: '542b5b34-c99c-4e4d-8692-080bb5796026',
  safety_2_0_forms_canmentionroles: '1e629ab6-eb2f-4d54-9ccd-3a6bfbe1f8bc',
  safety_2_0_forms_canreclassifyforms: '927e3ffb-bac7-4968-aaa4-1d1bfdce9c17',
  safety_2_0_forms_canreviewforms: '599cbd44-19d1-4c48-b513-630b44c53164',
  safety_2_0_forms_focusedauditforms: 'c0f447c6-80fe-4221-afa2-380e855805ef',
  safety_2_0_forms_formtopdf: '04d4d05d-28c7-411e-8464-c57e40b739d8',
  safety_2_0_forms_incidentforms: '3b35b3db-9039-43f1-bc4e-edb60b04289f',
  safety_2_0_forms_lastmodifieddetails: '4d03e67e-5df3-4fdf-b0d5-cc75d48608d9',
  safety_2_0_forms_observationforms: 'eff18972-0622-4485-b292-05bfe7e0933b',
  safety_2_0_forms_reportingforms: '69f9390f-e468-4bb3-838f-d8746a8a4f55',
  safety_2_0_lessons_learned_lessonslearnedcustomview:
    '13403f64-25e0-4880-9918-fcd715bc5551',
  safety_2_0_lessons_learned_lessonslearnedpage:
    '82c888da-88a0-4327-9fbf-1166f5be4a93',
  safety_2_0_lessons_learned_lessonslearnedsubmittedbyfilterandcolumn:
    'b4af09f2-dbaf-4458-a671-b048322ce6b8',
  safety_2_0_my_submissions_mysubmissionscustomview:
    'f050a6d9-dae5-4a86-b5c0-24566a322b5c',
  safety_2_0_my_submissions_mysubmissionspage:
    'b84227e1-7407-4e35-b978-cc4cdb9e7701',
  safety_2_0_participation_participationcustomview:
    '18e6e753-9d0b-4afc-b425-7cdee9e48ffb',
  safety_2_0_participation_participationgrid:
    'b347a0c6-ac8b-49de-b8cb-59b8925cb383',
  safety_2_0_review_forms_reviewformscustomview:
    '4472fb37-a2f9-4f14-a8f4-07620e43e901',
  safety_2_0_review_forms_reviewformspage:
    'd9804356-4f69-4793-963f-51868ea57c8d',
  safety_2_0_safety_forms_custom_dashboard_customdashboardcustomview:
    '16edd1fd-6836-47f9-acaf-112d4793ed84',
  safety_2_0_safety_forms_custom_dashboard_safetyformscustomdashboardpage:
    '88a657a5-5341-4562-a204-ec96ca003d01',
  safety_2_0_submission_requirements_submissionrequirementscustomview:
    '59405ceb-ec12-4fe8-ad05-ca9f33370182',
  safety_2_0_submission_requirements_submissionrequirementspage:
    '0fb974a5-3daa-4272-9956-f63e1c5c5983',
  Safety_2_0_Training_Sign_In_Page_trainingsigninpage:
    '359c1292-c414-4466-9c55-634390120147',
  Safety_Ask_Ryn_ask_ryn: '5942494a-3ed2-4114-88e6-dd54ff8f0352',
  safetyhazardcard_assignmentspage_assignmentspage:
    '57dd6829-e787-4a4f-9251-4597957ea864',
  safetyhazardcard_assignmentspage_classificationfrequencies:
    '01a52acb-bd72-4eb1-9a22-e7a435defce8',
  safetyhazardcard_assignmentspage_individualassignments:
    'f412fa53-e28d-427a-ada3-a6fb07446956',
  safetyhazardcard_coaching_coachtier5ops:
    'da2489a0-92d4-4094-b6d0-1e3460f88635',
  safetyhazardcard_detailscreens_viewdetailscreens:
    '9cdda093-f325-4b88-a5ef-646931ff2beb',
  safetyhazardcard_detailscreens_viewextendeddetailtabs:
    '5e1d19cc-349c-4f5b-8b7e-e225f74289a7',
  safetyhazardcard_eformspage_eformpage: '066c002a-bc11-4d94-8901-923d1b0ecc33',
  safetyhazardcard_hazardcardspage_createhazardcard:
    'd3837282-c750-44ed-b713-d4177827360c',
  safetyhazardcard_needsreviewpage_mitigationstrategy:
    '799ff1bb-457a-4a9b-a980-8b045eb067bf',
  safetyhazardcard_participationpage_participationpage:
    'd511fcc7-6af4-454c-bc54-852ee7e87b0d',
  safetyhazardcard_submissionspage_viewsubmissionspage:
    'a1625cfe-a88b-463a-952d-362880f92785',
  safetyhazardcard_summarypage_mystatistics:
    'de3f1c4f-9a0e-4aa8-ab13-7ff1c1f14d9f',
  safetyhazardcard_summarypage_viewsummarypage:
    '4efe5925-047e-4279-9c83-4e276743748c',
  safetyhazardcard_weeklysnapshotspage_hse_opsmanager:
    '9b7fcceb-b6fb-477e-a212-fd38e129912f',
  safetyhazardcard_weeklysnapshotspage_reviewhazardcardfromsnapshot:
    '2464475c-64d0-4302-9fe8-1197ae1a282b',
  safetyhazardcard_weeklysnapshotspage_viewweeklysnapshotspage:
    'a4510751-0963-43b0-b388-b26ec531363d',
  Security_Power_Bi_Software_Security_Reports_softwarerolesview:
    'be9cebc7-000f-4b1d-b934-a1ff45b442bf',
  software_security_architecture_apparchitecturediagram:
    '86360685-b65d-4ff9-8f8a-6a9b513324a2',
  Software_Security_Ask_Ryn_ask_ryn: '6f761912-ca9b-49e0-a21b-79b969fc031d',
  Software_Security_Code_Atlas_view: '47b55d7c-938a-424b-ae37-2707270c681d',
  software_security_devtools_security_jsonviewer:
    '28784b18-05ca-4dc2-b504-de4ff42e8ecb',
  Software_Security_It_Knowledge_view: 'fbd50168-9f84-4377-8934-f43a3673ebd3',
  software_security_it_portal_board_view:
    'f8784f8b-9172-4506-836b-a140eb4b65cd',
  software_security_it_portal_doers_view:
    '09b8ab51-6c6e-4d33-a06f-1c777e5ea2e9',
  software_security_it_portal_edit: '94ae527e-f200-4240-92d1-033388cff715',
  software_security_it_portal_leads_view:
    '538e0663-5d58-4594-9987-9881b8c5b969',
  software_security_it_portal_steerco_view:
    'd0825dc3-bef9-47e1-a89d-45c13c2c3636',
  Software_Security_Roles_managejobtitlesroles:
    'c5ece46c-dfdf-4f7d-99d6-907e8851b5e4',
  Software_Security_Ryn_Replay_ryn_replay_player:
    '9b8eb151-d9fe-455d-8c6f-37fe228d4d2f',
  Software_Security_Ryn_Replay_view_session_replays_web_operations_management:
    '8091fc8c-5d8b-414c-b739-b00e0202e859',
  Software_Security_Ryn_Replay_view_session_replays_web_ryns_roost:
    'e6e59f83-fa63-47a9-89c2-255463e402b3',
  Software_Security_Ryn_Replay_view_session_replays_web_safety:
    '2a5e7f2b-3867-4e00-9145-5dd0315d2095',
  Software_Security_Ryn_Replay_view_session_replays_web_software_security:
    '5bd5764f-67e1-48c8-8096-2937d81dda8c',
  Software_Security_Ryn_Replay_view_session_replays_web_sparta:
    'eaa27703-71eb-40e7-8cae-eec5e11bf58e',
  Software_Security_Ryn_Replay_view_session_replays_web_warehouse:
    '03468945-95d6-4b1b-8446-a965bf18d582',
  Software_Security_Ryn_Replay_viewsessionreplays_web_my_ups:
    '239ad970-35b5-4bdb-8084-4fa832596a47',
  Software_Security_Ryn_Replay_viewsessionreplays_web_resource_allocatiion:
    'ecee7e71-b323-4b26-94cd-47cb4d9ef0ae',
  Software_Security_Ryn_Replay_viewsessionreplays_web_ryn_replay:
    '6618a57f-7f5b-4758-a3c0-2620bdc89fc0',
  Software_Security_Ryn_Reports_view: 'c8d8cf07-2ac4-4cd1-a0f4-e8ef287e85d0',
  Software_Security_Unification_Release_Tracker_view:
    'bcb52b0a-20ff-41e8-858b-4fd808f429c1',
  Software_Security_Users_securityrequest:
    '94fb2fae-2619-49b8-bd56-44eb1a498b86',
  Software_Security_Users_userapplications:
    '62b7bd25-c44c-4543-ab06-33672276f7cb',
  Software_Security_Users_usersecuritydetails:
    'e67ce720-6939-4c35-84c5-bca38479c8d5',
  Software_Security_Users_usersecurityrequestoptions:
    'b02b0758-fc33-4bf1-8e0b-857cf56e38d4',
  software_security_users_usertenants: '22ba4b8c-aebe-4d9f-a570-3ca351896342',
  Software_Security_Viewpoint_Query_view:
    '34822095-cf27-4757-99fe-ddef9337cb10',
  softwaresecurity_administration_administrationtab:
    'c96ed056-9a9e-4c2f-9501-41ec8c77d139',
  softwaresecurity_releasenotes_managereleasenotes:
    '437d4612-a6d9-4068-9e41-1c204e4b3217',
  softwaresecurity_users_usercompanies: 'e07ec7bf-f800-4328-9f34-6edbc655292d',
  softwaresecurity_users_userinfo: '005a181c-5fba-45cd-b1fb-4ce1812aad41',
  softwaresecurity_users_userjobs: '4579db13-a6b6-4180-a52e-b5097969c5e4',
  softwaresecurity_users_userprgroups: '01efeef3-dcde-4a4f-b049-1a57eafd0f4f',
  softwaresecurity_users_userroles: '186ea356-8da6-40a2-a2e2-6c968514fe7f',
  Sparta_Ask_Ryn_ask_ryn: '1ae20435-f0dc-4208-a1bf-ea6b28f42247',
  SPARTA_Email_Notifications_email_notifications_admin:
    'c342b9f0-bcb0-4b00-970d-9ba3f2beacfe',
  SPARTA_Foreman_Time_Manager_createandexporttimesheets:
    '17896141-0df3-4483-b89e-db9602905083',
  SPARTA_Foreman_Time_Manager_foremantimemanagercustomview:
    'bacf9be7-6d29-47af-a19c-c36afb1c8220',
  SPARTA_Foreman_Time_Manager_foremantimemanagerpage:
    '56cb8db9-3bf7-4295-b2fc-19669f02ecc7',
  Sparta_Foreman_Time_Manager_rof_watch_list_power_bi:
    'fd3ede44-f616-4a13-9d46-2e3dc0fa1e12',
  sparta_testing_test2: 'e8d1a4a5-3651-4e67-aafc-35f22e0dcff7',
  sparta_testing_testfeature: '1e197dd0-3c60-46f0-ae95-6622969a572f',
  SPARTA_Track_Reconciliation_trackreconciliationpage:
    '0f20f8df-237c-46df-83c2-2e7ade159e7a',
  Theory_Of_Constraints_Theory_Of_Constraints_Access_theory_of_constraints_app:
    '187e0197-d828-4adb-80e2-57dab1b96304',
  Tool_Tracker_Mobile_Ask_Ryn__tool_Tracker_ask_ryn:
    '90fd40d8-f921-4813-be70-78e012de35a6',
  Total_Ryncall_Total_Ryncall_Admin_delete_transcript:
    '6d0be249-a010-4c2d-97e0-1eb8a95f9ba0',
  Total_Ryncall_Total_Ryncall_Admin_view_all_transcripts:
    'fc0f4cea-06c9-4511-9d1b-a67af19eff6e',
  ups_enterprise_app_site_application_list_olderbuilds:
    '9f75f3e1-9f77-4e12-89a8-15bcd303c472',
  Warehouse_Management_Ask_Ryn_ask_ryn: '5898b1b7-639a-4f88-9b0b-558bbbe81c6e',
  Warehouse_Management_Cycle_Count_adjustvariancecount:
    'c1f3f631-09aa-49e6-a75e-9ce986cf9a97',
  Warehouse_Management_Cycle_Count_cyclecountadmin:
    'a269270b-405b-4998-bc1b-80ef15fda1c0',
  Warehouse_Management_Cycle_Count_cyclecountuser:
    '10f8433a-b2d2-447f-8b4e-5d6a36c58ee8',
  Warehouse_Management_Kits_kits_page: '71ed3885-4690-47ed-9ca4-e80e639c5900',
  Warehouse_Management_WM___Orders_caneditdiscount:
    'ab2cea1a-8747-4dd9-9945-dc6760451ec9',
  Warehouse_Management_Wm_Backorders_backorders_page:
    'bc876d00-1f91-443f-a244-b440d8dde4db',
  Warehouse_Management_Wm_Code_Atlas_code_atlas_page:
    'b941148b-2bb5-4bce-9aab-10c9533773dc',
  Warehouse_Management_Wm_Customers_customer_replacement_outreach:
    'a8963d3a-b37d-4c29-8c2b-fd9f25a6cec2',
  Warehouse_Management_Wm_Customers_customers_page:
    '6932a460-3053-47f1-b52a-03910c74fa84',
  Warehouse_Management_Wm_Diagrams_diagram_page:
    '924f0265-a18c-4cbb-afbc-dee0a035a1f7',
  Warehouse_Management_Wm_Dock_Log_dock_log_custom_views:
    'c4b5ba0d-4d25-4773-aad7-a8fb8ca3dd02',
  Warehouse_Management_Wm_Dock_Log_dock_log_page:
    'cc2ac3bf-b568-4c3f-b66b-579be4ef74fa',
  Warehouse_Management_Wm_Inventory_add_new_material:
    '28715e6c-35ac-4061-b14e-fa3ecdbef7e0',
  Warehouse_Management_Wm_Inventory_addedit_sub_location:
    '6bbe00b9-cdb8-4e0e-85f8-f078b5db8fb2',
  Warehouse_Management_Wm_Inventory_can_see_prices:
    '650d3ba1-6b1b-4a40-9123-5583bc6759cc',
  Warehouse_Management_Wm_Inventory_inventory_history:
    '91be7b7b-c884-487b-a990-19d3d660c2ca',
  Warehouse_Management_Wm_Inventory_inventory_page:
    '337b4a35-b676-4595-9666-79c93706dff1',
  Warehouse_Management_Wm_Inventory_material_notes:
    '95882485-ece3-4891-9ea7-c3d6e9a68e2e',
  warehouse_management_wm_inventory_material_photos:
    '99351c33-dbef-44e9-a793-0118e658ca4f',
  Warehouse_Management_Wm_Inventory_materialvpupdatemodal:
    '5c68fccb-9835-495c-b73d-b7515bbe1903',
  Warehouse_Management_Wm_Knowledge_Base_knowledge_base_page:
    'f241823c-d3bc-4f37-84e3-2ac66bc9b626',
  Warehouse_Management_Wm_Label_Maker_create_sublocations:
    '241c1f90-b1eb-473e-a7a8-12bf542cf7b8',
  Warehouse_Management_Wm_Label_Maker_label_maker_page:
    'de44241a-d910-430a-a394-15a93c956aa8',
  Warehouse_Management_Wm_Mobile_Inventory_inventory_management:
    '6cbf82bd-c638-4efe-aca3-74b72cbd9cf6',
  Warehouse_Management_Wm_Mobile_Inventory_transfer_stock_and_print:
    '7bcd71af-5ad3-4342-ab38-7fa55d5b79fa',
  Warehouse_Management_Wm_Orders_create_quote:
    '2e8f856a-f5e2-4771-92c8-77757e776918',
  Warehouse_Management_Wm_Orders_edit_order:
    '55f83681-5cf2-4d91-ab80-96c0beb535cb',
  Warehouse_Management_Wm_Orders_fulfill:
    '21b8f4db-284e-4844-8329-5abaad28eb9f',
  Warehouse_Management_Wm_Orders_order_page:
    '08206fea-e1cf-4182-ad7c-93ae0053b277',
  Warehouse_Management_Wm_Orders_quote_to_sales_order:
    '2a799019-3609-431a-82c8-f1fb9b593a1d',
  Warehouse_Management_Wm_Powerbi_all_reports:
    '67be1f7b-dd0a-4a91-8b5a-ce045a004c60',
  warehouse_management_wm_quality_control_qc_admin:
    '978943a2-1630-4f72-82c4-d53d8539612d',
  warehouse_management_wm_quality_control_qc_page:
    '58b58d18-b31a-4c36-a5ab-9ea5b71981d5',
  Warehouse_Management_Wm_Vendors_vendor_page:
    '909cbe6a-cbe9-4082-baf9-9ad10c734d8d',
  weekly_summary: 'f3cefd46-175e-4170-b215-5d73237d8099',
};
